var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{staticClass:"gl-self-start",attrs:{"icon":_vm.badge.icon,"variant":_vm.badge.variant}},[_vm._v("\n  "+_vm._s(_vm.humanStatus)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }